import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18.364 19.364a9 9 0 1 0 -12.728 0","key":"svg-0"}],["path",{"d":"M15.536 16.536a5 5 0 1 0 -7.072 0","key":"svg-1"}],["path",{"d":"M11 13a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-2"}]]

const IconBroadcast = createReactComponent('outline', 'broadcast', 'Broadcast', __iconNode);

export default IconBroadcast;